export default {"src":"/_next/static/media/icon-ga-logo-alert.eb7aa7d3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};